import React from 'react';
import {
  minValue,
  required,
  SelectInput,
} from 'react-admin';

import {
  Grid,
} from '@mui/material';

import { timePeriodChoices } from '../../../constants/timePeriods';

import Label from '../../../customFields/Label';

import NumberInput from '../../layout/inputFields/NumberInput';
import { DefaultThresholdInput } from './ThresholdInput';

const SuspiciousFunds = () => (
  <Grid size={12}>
    <Grid container spacing={1}>
      <Grid size={12}>
        <DefaultThresholdInput />
      </Grid>
      <Grid size={12}>
        <Label
          variant="label"
          title="Period"
          info="The period that the threshold will be checked against."
        />
      </Grid>
      <Grid size={6}>
        <NumberInput
          source="ruleParameters.period.amount"
          fullWidth
          label="Length"
          validate={[required(), minValue(1)]}
        />
      </Grid>
      <Grid size={6}>
        <SelectInput
          source="ruleParameters.period.unit"
          choices={timePeriodChoices}
          fullWidth
          label="Period"
          validate={[required(), minValue(1)]}
        />
      </Grid>
    </Grid>
  </Grid>
);

export default SuspiciousFunds;
